import React, { FC } from "react";
import Head from "next/head";
import { SearchFormBox } from "components/blog/searchformbox";
import Breadcrumb, { Crumb } from "components/Breadcrumb";
import { Layout } from "layouts/Layout";
import { assetPrefix } from "prefix";
import { BreadCrumbStructuredData } from "components/StructuredData";
import Styles from "./styles-global.scss";

interface BlogLayoutProps {
    pageType: string;
    breadcrumbTrail: Crumb[];
    mainClass: string;

    canonicalUrl?: string;
    category?: string;
    description?: string;
    headerTitle?: string;
    metaDescription?: string;
    pageName?: string;
    searchCategory?: string;
    socialMediaImage?: string;
    title?: string;
}

const BlogLayout: FC<BlogLayoutProps> = ({
    children,
    title,
    description,
    socialMediaImage,
    mainClass,
    category,
    headerTitle,
    breadcrumbTrail,
    searchCategory,
    canonicalUrl,
    metaDescription,
    pageName,
    pageType
}) => {
    return (
        <Layout
            pageType={pageType}
            {...{
                ...(title && { title: `${title} - AutoTrack` }),
                ...(description && { description }),
                ...(socialMediaImage && { socialMediaImage }),
                ...(canonicalUrl && { canonicalUrl }),
                ...(pageName && { pageName }),
                ...(metaDescription && { metaDescription })
            }}
        >
            <style jsx>{Styles}</style>
            <Head>
                <link
                    rel="stylesheet"
                    href={`${assetPrefix}/static/styles/blog.css?version=${process.env.VERSION}`}
                />
            </Head>
            <div className="blog">
                <div className={`${mainClass} main-content`}>
                    <div className="custom-container">
                        <SearchFormBox
                            category={category}
                            title={headerTitle || title}
                            searchCategory={searchCategory}
                        />
                        <Breadcrumb trail={breadcrumbTrail} />
                        <BreadCrumbStructuredData trail={breadcrumbTrail} />
                        {children}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

BlogLayout.defaultProps = {
    category: "Nieuws",
    searchCategory: "nieuws",
    pageName: "blog-unknown-page"
};

export default BlogLayout;
